import React from "react";
import { CameraIcon, ClipboardCheckIcon, FileTextIcon, MapIcon, Table2Icon, PrinterIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { tools, ToolIcon } from "../../data/landing";
const iconMap: Record<ToolIcon, React.ComponentType<{
  className?: string;
}>> = {
  sheet: FileTextIcon,
  checklist: ClipboardCheckIcon,
  map: MapIcon,
  matrix: Table2Icon,
  camera: CameraIcon
};
export function Tools() {
  return <section className="bg-navy px-4 py-16 sm:py-24" data-id="element-308" data-mp="23s4ttt17hz6v">
      <div className="mx-auto max-w-4xl" data-id="element-309" data-mp="23qjxbxvc066d">
        <SectionHeading dark eyebrow="Plus" title="You'll also receive these professional tools" data-id="element-310" data-mp="1yt0eslrlp78m" />
        <ul className="mt-10 divide-y divide-white/10 rounded-3xl bg-navy-700 px-5 sm:px-8" data-id="element-311" data-mp="1tuyxa59tpfz9">
          {tools.map(t => {
          const Icon = iconMap[t.icon];
          return <li key={t.title} className="flex items-start gap-4 py-5" data-id="element-312" data-mp="1kt8xab1vl8pv">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gold text-navy" data-id="element-313" data-mp="1kw4xk61749hh">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-314" data-mp="19zwkpaby2v64" />
                </span>
                <div data-id="element-315" data-mp="w8rs2s6zv35a">
                  <h3 className="text-lg font-bold text-white" data-id="element-316" data-mp="w9b823d33hgo">{t.title}</h3>
                  <p className="mt-1 text-[16px] leading-relaxed text-white/75" data-id="element-317" data-mp="10ad122geqxa7">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>
        <p className="mt-6 flex items-center justify-center gap-2 text-center font-semibold text-gold-light" data-id="element-318" data-mp="1o0qt3syzsw4s">
          <PrinterIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-319" data-mp="1swy0lq71efou" />
          Everything is designed to be downloaded, printed and reused.
        </p>
        <div className="mt-10" data-id="element-320" data-mp="1jxaz74eb59vs">
          <CtaButton label="I want access to the complete system" data-id="element-321" data-mp="1jwj4rwwg5i73" />
        </div>
      </div>
    </section>;
}